import React from 'react';
import { observer } from 'mobx-react';

import { InjectedStyledComponent, SvgElement } from '../../../shared/index.js';
import Container from '../Container/Container.js';

import { ISvgPolygonConfiguration, ISvgPolygonProps, ISvgPolygonState } from './models/index.js';
import Wrapper from './styledComponents/Wrapper.js';
import { SVG_POLYGON_CATEGORY_KEY, SVG_POLYGON_COMPONENT_KEY } from './SvgPolygon.meta.js';

export class SvgPolygon extends SvgElement<ISvgPolygonProps, ISvgPolygonState, ISvgPolygonConfiguration> {
	categoryKey = SVG_POLYGON_CATEGORY_KEY;
	componentKey = SVG_POLYGON_COMPONENT_KEY;

	render() {
		const { className, ...allSvgProps } = this.props;
		const svgProps = this.getElementSvgProps<SVGPolygonElement>(undefined, {
			points: allSvgProps.points.map((point) => `${point.x},${point.y}`).join(' '),
		});
		const baseProps = this.getBaseSvgProps();
		return (
			<Wrapper className={className}>
				<Container {...baseProps}>
					<polygon {...svgProps} />
				</Container>
			</Wrapper>
		);
	}
}

export default InjectedStyledComponent(observer(SvgPolygon), SVG_POLYGON_CATEGORY_KEY, SVG_POLYGON_COMPONENT_KEY);
